import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { AddContact } from './components/AddContact';
import { EditContact } from './components/EditContact';
import { Contacts } from './components/Contacts';
import { Researchers } from './components/Researchers';
import { AddResearcher } from './components/AddResearcher';
import { EditResearcher } from './components/EditResearcher';
import { Statistics } from './components/Statistics';
import { ManageUsers } from './components/ManageUsers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash, faEdit, faEye, faPlusSquare, faTrashRestore, faFilter } from '@fortawesome/free-solid-svg-icons';
import './custom.css';

library.add(faTrash, faEdit, faEye, faPlusSquare, faTrashRestore, faFilter);

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                {/* Use AuthorizeRoute instead of Route to require authentication */}
                <Route exact path='/' component={Home} />
                {/*<Route path='/fetch-data' component={FetchData} />*/}
                {/*<Route path='/add-contact' component={AddContact} />*/}
                {/*<Route path='/edit-contact' component={EditContact} />*/}
                {/*<Route path='/contacts' component={Contacts} />*/}
                {/*<Route path='/researchers' component={Researchers} />*/}
                {/*<Route path='/add-researcher' component={AddResearcher} />*/}
                {/*<Route path='/edit-researcher' component={EditResearcher} />*/}
                {/*<Route path='/statistics' component={Statistics} />*/}
                {/*<Route path='/manage-users' component={ManageUsers} />*/}
                <AuthorizeRoute roles="Admin" path='/manage-users' component={ManageUsers} />
                <AuthorizeRoute roles="Member, Admin" path='/fetch-data' component={FetchData} />
                <AuthorizeRoute roles="Member, Admin" path='/add-contact' component={AddContact} />
                <AuthorizeRoute roles="Member, Admin" path='/edit-contact' component={EditContact} />
                <AuthorizeRoute roles="Member, Admin" path='/contacts' component={Contacts} />
                <AuthorizeRoute roles="Member, Admin" path='/researchers' component={Researchers} />
                <AuthorizeRoute roles="Member, Admin" path='/add-researcher' component={AddResearcher} />
                <AuthorizeRoute roles="Member, Admin" path='/edit-researcher' component={EditResearcher} />
                <AuthorizeRoute roles="Member, Admin" path='/statistics' component={Statistics} />
                
                <div id="modal-root"></div>
                <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
            </Layout>
        );
    }
}
